module.exports = __webpack_public_path__ + "media/day/260-263a02ec.svg";